import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

import { finalize, from, mergeMap, tap } from 'rxjs';

import { APP_ENVIRONMENT } from '@app/shared/tokens';
import { transformToCdnUrl } from '@app/shared/util';
import { Store } from '@ngxs/store';
import { AngularNodeViewComponent } from 'ngx-tiptap';

@Component({
    selector: 'shared-tiptap-file-container',
    templateUrl: './tiptap-file-container.component.html',
    styleUrls: ['./tiptap-file-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatButton, MatIcon, MatProgressSpinner],
})
export class TiptapFileContainerComponent extends AngularNodeViewComponent {
    isDownloading = false;
    cd = inject(ChangeDetectorRef);
    env = inject(APP_ENVIRONMENT);
    store = inject(Store);

    get fileName(): string {
        return this.node().attrs['title'] || '';
    }

    get href(): string {
        return this.node().attrs['data-href'] || '';
    }

    onDownloadFile() {
        this.isDownloading = true;

        const options = { headers: {} };

        if (!this.href) {
            this.isDownloading = false;
            return;
        }

        const url = transformToCdnUrl(this.href, this.env, 'file');

        if (url.includes(this.env.privateContainerName)) {
            const token = this.store.selectSnapshot(root => root.auth.token);
            options['headers'] = { Authorization: `Bearer ${token.token}` };
        }

        from(fetch(url, options))
            .pipe(
                mergeMap(response => response.blob()),
                tap(blob => {
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = this.fileName as string;
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                }),
                finalize(() => {
                    this.isDownloading = false;
                    this.cd.detectChanges();
                }),
            )
            .subscribe();
    }
}
